import { combineReducers } from "@reduxjs/toolkit";
import auth from "./auth/reducer";
import users from "./users/reducer";
import homes from "./home/reducer";
import subservices from "./subservices/reducer";
import contact from "./contactus/reducer";
import faqs from "./faq/reducer";
import marketings from "./marketing/reducer";
import giftscards from "./giftcards/reducer";
import restaurant from "./restaurant/reducer";
import community from "./community/reducer";
import eventmanagement from "./eventmanagement/reducer";
import dishes from "./dishes/reducer";
import slots from "./slots/reducer";
import adddish from "./adddish/reducer";
import discountfilter from "./discountfilter/reducer";
import cuisines from "./cuisines/reducer";

export default combineReducers({
  auth,
  users,
  cuisines,
  subservices,
  homes,
  contact,
  faqs,
  marketings,
  giftscards,
  restaurant,
  community,
  eventmanagement,
  dishes,
  slots,
  adddish,
  discountfilter,
});
